import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    getAllStudents,
    getAllInstructors,
    getAllAssistants,
} from '../../../../API/getUsers';
import { blockUser, unBlockUser } from '../../../../API/Users';

export const fetchStudents = createAsyncThunk(
    'users/fetchStudents',
    async (_, { rejectWithValue }) => {
        try {
            const data = await getAllStudents();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const fetchInstructors = createAsyncThunk(
    'users/fetchInstructors',
    async (_, { rejectWithValue }) => {
        try {
            const data = await getAllInstructors();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const fetchAssistants = createAsyncThunk(
    'users/fetchAssistants',
    async (_, { rejectWithValue }) => {
        try {
            const data = await getAllAssistants();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const blockUserThunk = createAsyncThunk(
    'users/blockUser',
    async (id, { rejectWithValue }) => {
        try {
            const res = await blockUser(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

export const unBlockUserThunk = createAsyncThunk(
    'users/unBlockUser',
    async (id, { rejectWithValue }) => {
        try {
            const res = await unBlockUser(id);
            return res.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

const initialState = {
    students: [],
    instructors: [],
    assistants: [],
    loading: false,
    error: null,
};

const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // fetchStudents
            .addCase(fetchStudents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStudents.fulfilled, (state, action) => {
                state.loading = false;
                state.students = action.payload;
            })
            .addCase(fetchStudents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            // fetchInstructors
            .addCase(fetchInstructors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchInstructors.fulfilled, (state, action) => {
                state.loading = false;
                state.instructors = action.payload;
            })
            .addCase(fetchInstructors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            // fetchAssistants
            .addCase(fetchAssistants.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAssistants.fulfilled, (state, action) => {
                state.loading = false;
                state.assistants = action.payload;
            })
            .addCase(fetchAssistants.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            // blockUserThunk
            .addCase(blockUserThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(blockUserThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(blockUserThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            // unBlockUserThunk
            .addCase(unBlockUserThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(unBlockUserThunk.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(unBlockUserThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export default usersSlice.reducer;
